import classNames from "classnames";
import { CLIENT_FILTERS, type ClientFilter } from "../_helpers/clientFilter";

interface StatusFilterChipsProps {
    /** Currently active chip, or null for "All". */
    active: ClientFilter | null;
    /** Fired with the selected chip, or null when "All" is chosen. */
    onSelect: (filter: ClientFilter | null) => void;
}

// "All" is the absence of a filter. The chips carry no counts: the
// /organizations/statuses counts are of locations, the list's of clients (C1).
const CHIPS: { label: string; value: ClientFilter | null }[] = [
    { label: "All", value: null },
    ...CLIENT_FILTERS.map((filter) => ({ label: filter.label, value: filter })),
];

export const StatusFilterChips = ({
    active,
    onSelect,
}: StatusFilterChipsProps) => {
    return (
        <div className="mt-5 flex flex-wrap items-center gap-2" role="group" aria-label="Filter by status">
            {/* The group's name already says this to screen readers. */}
            <span className="font-bold text-neutral" aria-hidden="true">
                Filters:
            </span>
            {CHIPS.map(({ label, value }) => {
                const isActive = active?.key === value?.key;
                return (
                    <button
                        key={label}
                        type="button"
                        aria-pressed={isActive}
                        onClick={() => onSelect(value)}
                        className={classNames(
                            "btn btn-sm rounded-full",
                            isActive
                                ? "btn-primary"
                                : "btn-outline text-neutral",
                        )}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
};
